var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mx-auto"},[_c('v-img',{staticClass:"grey",attrs:{"height":"200px"}}),_c('v-card-title',[_vm._v(_vm._s(_vm.user.uid))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.user.displayName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }